// extracted by mini-css-extract-plugin
module.exports = {"main":"AlgoliaLocationFilter_main__x2b_R"};